import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, Alert, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import 'react-block-ui/style.css';
import { fetchSubscription, cancelSubscription, SUBSCRIPTION_FETCH_REQUEST, SUBSCRIPTION_FETCH_SUCCESS, SUBSCRIPTION_FETCH_FAILURE,
	SUBSCRIPTION_CANCEL_REQUEST, SUBSCRIPTION_CANCEL_FAILURE } from './actions';
import { formatDay } from './SubscriptionStatus';

// the first validation message from the API, or its title
const getErrorMessage = (errorResponse, t) => {
	if (errorResponse && errorResponse.errors) {
		const messages = Object.values(errorResponse.errors).reduce((all, x) => all.concat(x), []);
		if (messages.length > 0) {
			return messages[0];
		}
	}
	return (errorResponse && (errorResponse.detail || errorResponse.title)) || t('BadRequest_Message');
};

/**
 * Online cancellation: one page showing what cancelling now means, and one button to confirm.
 */
class CancelSubscription extends Component {
	constructor(props) {
		super(props);
		this.handleConfirm = this.handleConfirm.bind(this);
		this.state = {
			subscription: null,
			errorMessage: null
		};
	}

	componentDidMount() {
		const { t } = this.props;
		this.props.fetchSubscription(this.paymentId(),
			response => this.setState({ subscription: response }),
			errorResponse => this.setState({ errorMessage: getErrorMessage(errorResponse, t) }));
	}

	paymentId() {
		return Number(this.props.match.params.id);
	}

	handleConfirm() {
		const { t, history } = this.props;
		this.setState({ errorMessage: null });
		this.props.cancelSubscription(this.paymentId(),
			() => history.push(`/payment-history/${this.paymentId()}/lesson?subscriptionCancelled=true`),
			errorResponse => this.setState({ errorMessage: getErrorMessage(errorResponse, t) }));
	}

	renderCancellation(cancellation, offlineCancellationInstructions) {
		const { t } = this.props;
		return <div>
			<p>{t('FO_Subscription_Cancel_Intro')}</p>
			<ul>
				<li>{cancellation.withinCoolingOff
					? t('FO_Subscription_Cancel_LastDay_CoolingOff')
					: t('FO_Subscription_Cancel_LastDay', { date: formatDay(cancellation.lastDay) })}</li>
				{cancellation.owedPayments.length > 0
					? <li>
						{t('FO_Subscription_Cancel_OwedPayments')}
						<ul>{cancellation.owedPayments.map(x => <li key={x.chargeDate}>{t('FO_Subscription_Cancel_OwedPayment', { amount: x.amount, date: formatDay(x.chargeDate) })}</li>)}</ul>
					</li>
					: <li>{t('FO_Subscription_Cancel_NoMorePayments')}</li>}
				{cancellation.withinCoolingOff && <li>{t('FO_Subscription_Cancel_Refund', { amount: cancellation.refundAmount })}</li>}
			</ul>
			{/* the franchisor's own HTML, like the T&Cs */}
			{offlineCancellationInstructions && <p>{t('FO_Subscription_Cancel_Offline')} <span dangerouslySetInnerHTML={{ __html: offlineCancellationInstructions }} /></p>}
		</div>;
	}

	render() {
		const { t } = this.props;
		const { subscription, errorMessage } = this.state;
		const detailsUrl = `/payment-history/${this.paymentId()}/lesson`;
		const cancellation = subscription && subscription.cancellation;

		return <ReduxBlockUi block={[SUBSCRIPTION_FETCH_REQUEST, SUBSCRIPTION_CANCEL_REQUEST]} unblock={[SUBSCRIPTION_FETCH_SUCCESS, SUBSCRIPTION_FETCH_FAILURE, SUBSCRIPTION_CANCEL_FAILURE]}>
			<Row className='parent-dashboard-box'>
				<Col sm={12}>
					<h3>{t('FO_Subscription_Cancel_Title')}</h3>
					{errorMessage && <Alert bsStyle='danger'>{errorMessage}</Alert>}
					{subscription && !cancellation && <Alert bsStyle='info'>{t('FO_Subscription_Cancel_NotCancellable')}</Alert>}
					{cancellation && this.renderCancellation(cancellation, subscription.offlineCancellationInstructions)}
					<div style={{ marginTop: 20 }}>
						{cancellation && <Button bsStyle='danger' onClick={this.handleConfirm}>{t('FO_Subscription_Cancel_Confirm')}</Button>}
						<Link className='btn btn-link' to={detailsUrl}>{t(cancellation ? 'FO_Subscription_Cancel_Keep' : 'FO_Payment_Details')}</Link>
					</div>
				</Col>
			</Row>
		</ReduxBlockUi>;
	}
}

CancelSubscription.propTypes = {
	match: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	fetchSubscription: PropTypes.func.isRequired,
	cancelSubscription: PropTypes.func.isRequired
};

export default connect(null, {
	fetchSubscription,
	cancelSubscription
})(withTranslation()(CancelSubscription));
